import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';
import { dateFNS } from '@gogame/intl-ts';

import {
  FILTER_CREATED,
  FILTER_STATUSES,
  FILTER_SHOW,
  FILTER_TYPE,
  FILTER_AFFILIATES,
  FILTER_NETWORKS,
  FILTER_APPLICATIONS,
  FILTER_PLATFORMS,
  FILTER_CREATED_BY,
  FILTER_CHANNELS,
} from 'scenes/SmartRules/constants';
import {
  loadStatuses,
  loadShowModes,
  loadTypes,
  loadAffiliates,
  loadNetworks,
  loadApplications,
  loadPlatforms,
  loadCreatedBy,
  loadChannels,
} from 'scenes/SmartRules/sources/filters';

const CreatedFilter = (props) => {
  return (
    <Filter.DateRangePicker
      timeZone={'utc'}
      title={'Created'}
      placeholder={'All'}
      name={FILTER_CREATED}
      variant={'outlined'}
      maxDate={dateFNS.endOfYear(new Date())}
      {...props}
    />
  );
};

const StatusesFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Statuses'}
      name={FILTER_STATUSES}
      source={loadStatuses}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

const ShowModeFilter = (props) => {
  return (
    <Filter.Select
      title={'Show'}
      name={FILTER_SHOW}
      source={loadShowModes}
      placeholder={'All'}
      withAll={false}
      {...props}
    />
  );
};

const TypeFilter = (props) => {
  return (
    <Filter.Select
      title={'Type'}
      name={FILTER_TYPE}
      source={loadTypes}
      placeholder={'All'}
      withAll={false}
      {...props}
    />
  );
};

const AffiliatesFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Affiliates'}
      name={FILTER_AFFILIATES}
      source={loadAffiliates}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

const NetworksFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Networks'}
      name={FILTER_NETWORKS}
      source={loadNetworks}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

const ApplicationsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={loadApplications}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

const PlatformsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Platforms'}
      name={FILTER_PLATFORMS}
      source={loadPlatforms}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

const CreatedByFilter = (props) => {
  return (
    <UserFilter
      title={'Created by'}
      name={FILTER_CREATED_BY}
      source={loadCreatedBy}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

const ChannelsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Channels (by affiliates)'}
      name={FILTER_CHANNELS}
      source={loadChannels}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

export default {
  Created: CreatedFilter,
  Statuses: StatusesFilter,
  ShowMode: ShowModeFilter,
  Type: TypeFilter,
  Channels: ChannelsFilter,
  Affiliates: AffiliatesFilter,
  Networks: NetworksFilter,
  Applications: ApplicationsFilter,
  Platforms: PlatformsFilter,
  CreatedBy: CreatedByFilter,
};
